import React, { useEffect, useState } from 'react';

import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';

import Master from '../Layouts/Master';

const Success = () => {
  const { search } = useLocation();
  const [params, setParams] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = queryString.parse(search);
    if (
      queryParams.tracking_id === undefined ||
      queryParams.tracking_id.length === 0
    ) {
      return navigate('/', { replace: true });
    }
    setParams(queryParams);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  return (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            پرداخت موفق
          </h1>
        </div>
      </div>
      <div className='row'>
        <div className='col-12 col-md-6 offset-md-3'>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <i className='fad fa-check-circle text-success f-90 my-2'></i>
            <span className='text-success f-18 font-weight-bold  my-2'>
              پرداخت شما با موفقیت انجام شد کد پیگیری پرداخت شما :{' '}
            </span>
            <span className='text-success f-18 font-weight-bold my-2'>
              {params?.tracking_id}
            </span>
          </div>
        </div>
      </div>
    </Master>
  );
};

export default Success;
